import type { EventModel, VenueSummary } from '../models/EventModel';

export function getVenueLabel(venue?: VenueSummary | null, fallback = ''): string {
  return venue?.name?.trim() || fallback.trim();
}

export function getVenuePathFromVenue(venue?: VenueSummary | null, fallback = ''): string {
  if (venue?.slug?.trim()) {
    return `/venue/${encodeURIComponent(venue.slug)}`;
  }

  return `/venue/${encodeURIComponent(fallback.trim())}`;
}

export function getVenuePathFromEvent(event: Pick<EventModel, 'venue' | 'locationName'>): string {
  return getVenuePathFromVenue(event.venue, event.locationName || '');
}
